var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4eac99",
    height: "800px",
    width: "800px",
    id: "XMLID_7_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3v18h24V3H0z M21.9,5L12,13.1L2.1,5H21.9z M2,19V7.5l10,8.2l10-8.2V19H2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/social3.80fc3cdda1a9b55dd4ef1c438faa81e6.svg";
export { ForwardRef as ReactComponent };